import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const restoreRateCard = api(async function restoreRateCard({ id }) {
    return mutate(
        gql`
            mutation RestoreRateCard($id: String!) {
                restoreRateCard(id: $id)
            }
        `,
        { id },
        { returns: "restoreRateCard" }
    )
})
